export namespace ToroEnums {

    export enum ToroColor {
        ToroRed = '#cd2027',
        EtTrendUp = ToroRed,
        EtTrendDown = '#3178c6',
    }

    export enum WidgetType {
        Test,
        LynxRunningStations,
        LynxPumpStation,
        TurfGuardSalinity,
        TurfGuardMoisture,
        TurfGuardTemperature,
        WeatherRadar,
        FrostWarning,
        Evapotranspiration,
        LocalWeatherForecast,
        WeatherGraphs,
        GreenSight,
        MyTurfOrders,
        MyTurfMaintenance,
        TurfCloudCourseTrakk,
        TurfCloudLaborStats,
        EquipmentTracking,
        Nsn,
        LynxPumpStations,
        LynxLocalCurrentWeather,
        LynxLocalWeatherGraphs,
        LynxPumpStationsWithGauges,
        Playbooks,
        TaskTrackerLaborSummary,
        TaskTrackerDailyMeasurements,
        TaskTrackerSafety,
        DecisionTree,
        EzLocator,
        LynxStationStatuses,    // aka Lynx Cloud
        GeoFencing,
        PerryWeather,
        Gcsaa,
        GcsaaAlt,
        WeatherAverages,
        SoilScoutSalinity,
        SoilScoutMoisture,
        SoilScoutTemperature,
        Pogo,
        TaskTrackerTurfRad,
        SoilScoutMobile,
        SoilScoutMap,
        Notes,
        SpectrumMoisture,
        DtnWeather,
        StrikeGuard,
        Maya,
        Intelli360Maintenance,
        Intelli360AssetDown,
        Intelli360WorkOrders,
        Intelli360OperatingStatus,
        TurfProAssetStatus,
    }

    export enum LanguageCode {
        Bulgarian = 'bg-bg',
        Chinese_Simplified = 'zh-cn',
        Czech = 'cz-cz',
        Danish = 'da-dk',
        Dutch = 'nl-nl',
        English_US = 'en-us',
        French = 'fr-fr',
        German = 'de-de',
        Italian = 'it-it',
        Japanese = 'ja-jp',
        Norwegian = 'nn-no',
        Portuguese = 'pt-pt',
        Russian = 'ru-ru',
        Spanish = 'es-es',
        Swedish = 'sv-se',
        Thai = 'th-th',
        Korean = 'ko-ko',
        Vietnamese = 'vi'
    }

    // https://www.iban.com/currency-codes
    export enum CurrencyCode {
        UsDollar = 'USD',
        Euro = 'EUR',
        MexicanPeso = 'MXN',
        BrazilianReal = 'BRL',
        SwedishKrona = 'SEK',
        Yen = 'JPY',
        Won = 'KRW',                // Korea
        YuanRenminbi = 'CNY',
        Dong = 'VND',               // Vietnam
        RussianRuble = 'RUB',
        BulgarianLev = 'BGN',
        NorwegianKrone = 'NOK',
        CzechKoruna = 'CZK'
    }

    export enum DateFormat {
        MMsDDsYY = 'MM/DD/YY',
        MMhDDhYY = 'MM-DD-YY',
        MMdDDdYY = 'MM.DD.YY',
        DDsMMsYY = 'DD/MM/YY',
        DDhMMhYY = 'DD-MM-YY',
        DDdMMdYY = 'DD.MM.YY',
    }

    export enum MessageSeverity {
        Info = 'info',
        Success = 'success',
        Warn = 'warn',
        Error = 'error'
    }

    export enum ForecastCondition {
        Sunny,
        PartlySunny,
        Cloudy,
        PartlyCloudy,
        Showers,
        Rainfall,
        Thunderstorms,
        Snow,
        Sleet,
        FreezingRain,
        Drizzle,
    }

    export enum UnitsSystem {
        Imperial,
        Metric,
    }

    export enum TemperatureUnits {
        Fahrenheit,
        Celsius,
    }

    export enum GroupAndDecimalSeparator {
        CommaPeriod = 'en-us',
        PeriodComma = 'de-de'
    }

    export enum GaugeColor {
        Low = '#5a93d1',
        Mid = '#6bb878',
        High = '#DF5353',
    }

    export enum TurfGuardSensorType {
        Invalid,
        Temperature,
        Moisture,
        Salinity,
    }

    export enum TurfGuardChartColor {
        Bar = '#739CC6',        // '#739CC6', '#A5AAD9'
        Line = '#739CC6',
        BarText = '#555',
        HighLimit = '#FF0000',
        LowLimit = '#0000FF',
        Alert = '#eb5e25',
    }

    export enum WeatherGraphType {
        DewPoint,
        Wind,
        Temperature,
        Precipitation,
        SolarRadiation,
        RelativeHumidity,
    }

    export enum WeatherGraphChartColor {
        DewPoint = '#5CB85C',
        Temperature = 'darkmagenta',
        Precipitation = 'dodgerblue',
        Wind = 'darkgray',
        SolarRadiation = 'orange',
        RelativeHumidity = 'chocolate'
    }

    export enum PlaybooksNutrientColor {
        N = '#8cc63f',
        P = '#0f75bc',
        K = '#92278f',
        Fe = '#fcb040',
        Mn = '#ed1c24'
    }

    export enum PlaybooksGddColor {
        GDD0 = '#98C455',           // '#8cc63f',
        GDD10 = '#3573B7',          //'#0f75bc',
        GDD32 = '#86308B',          //'#92278f',
        GDD50 = '#F1B357',          //'#fcb040',
    }

    export enum PlaybooksChartType {
        Nutrient,
        Gdd,
    }

    export enum PlaybooksLinkType {
        ApplicationLog = 'APPLICATION LOG',
        Dashboard = 'DASHBOARD',
        Reports = 'REPORTS',
        Documents = 'DOCUMENTS',
        Inventory = 'INVENTORY',
        NotificationsCenter = 'NOTIFICATIONS CENTER'
    }

    export enum AssetTrackingAssetStatus {
        Off = 1,
        Idle = 2,
        Transporting = 3,
        Working = 4,
        NeedsAttention = 5,
        NotUsed = 6,
        Unavailable = 7,
        On = 8
    }

    export enum FrostRisk {
        None,
        High
    }

    export enum GreenSightViewer {
        Course = 'CourseViewer',
        Greens = 'GreenViewer',
        Favorites = 'Favorites'
    }

    export enum HttpStatusCode {
        BadRequest = 400,
        Unauthorized = 401,
        Forbidden = 403,
        FailedDependency = 424,
    }

    export enum SiteDataCategoryType {
        MyTurf,
        Lynx,
        TurfCloud,
        TurfGuard,
        Weather,
        AssetTracking,
        Playbooks,
        Geofence
    }

    export enum AlertType {
        Temperature,
        Moisture,
        Salinity,
        Humidity,
        WindSpeed,
        Pressure,
        Flow,
        FrostLevel,
    }

    export enum AlertThresholdType {
        TooLow,
        TooHigh,
        Other
    }

    export enum AlertSeverity {
        Information,
        Moderate,
        High,
        Severe
    }

    export enum AlertDataLevel {
        Site,
        Course,
        Hole,
        Sensor
    }

    export enum TopologyCategory {
        AreaTopology,
        TGTopology,
        StationActivity,
        Pumps,
        Sensors,
        Weather,
        WeatherRadar,
        LynxWeatherStations,
    }

    export enum CalAmpAccumulators {
        VB_Operating_Status = 0,
        VB_Key_On_Timer = 20,
    }

    export enum CalAmpDeviceStatus {
        Off = 0,
        Idle = 1,
        Transport = 2,
        Work = 3
    }

    export enum AssetTrackingDeviceType {
        Unknown,
        GreensRide,
        GreensWalk,
        OutCross,
        ProCore,
        ProForce,
        ProPass,
        ProSweep,
        Reels,
        Rotary,
        SandPro,
        Sprayers,
        Utility
    }

    export enum AssetTrackingDeviceStatus {
        Unknown = -1,
        Off = 0,
        Idle = 1,
        Transport = 2,
        Work = 3
    }

    export enum CalAmpDeviceType {
        Unknown,
        HMU3640,
        TTU2830
    }

    export enum NsnError {
        Unknown = 0,
        NsnDashAccessError = 1,
        NsnLoginError = 2
    }

    export enum LynxStationStatus {
        Unknown,
        Running,
        RanUnder
    }

    export enum WizardIntegration {
        MyTurf,
        PerryWeather,
        // AssetTracking,
        Playbooks,
        TaskTracker,
        EzLocator,
        SoilScout,
        Spectrum,
        StrikeGuard,
        Maya,
        Intelli360,
        TurfPro
    }

    export enum WizardFaq {
        NotUpdating,
        ShowHideWidgets,
        CustomIntegrations,
        RealTimeUpdates
    }

    export enum WeatherAverageSources {
        Average,
        ToroDtnWeather,
        PerryWeather,
        Lynx,
    }

    export enum WeatherAverageType {
        Temperature,
        Et,
        Humidity,
        Precipitation
    }

    export enum PerryWeatherChartType {
        Precipitation,
        Et
    }

    export enum PwChartDataType {
        PrecipForecast,
        PrecipHistorical,
        EtHistorical
    }

    export enum PogoMoistureRating {
        CriticallyLow,
        Low,
        Good,
        High,
        CriticallyHigh
    }

    export enum PogoTopNav {
        Moisture,
        DistributionUniformity,
        TurfPerformance
    }

    export enum PwChartType {
        Precip,
        Et
    }

    export enum PwChartPeriod {
        Historic,
        Forecast
    }

    export enum SoilScoutSensorType {
        Invalid,
        Temperature,
        Moisture,
        Salinity,
        WaterBalance
    }

    export enum SoilScoutGaugeColor {
        Red = '#DF5353',
        Yellow = '#fbe106',
        Green = '#6bb878',
        Blue = '#5a93d1'
    }

    export enum SoilScoutThresholdTab {
        Moisture,
        Salinity,
        Temperature
    }

    export enum SoilScoutMapView {
        Moisture,
        Temperature,
        Salinity,
        Connectivity
    }

    export enum SpatialAdjustEntityType {
        Course = 2,
        ProgramStation = 7,
        Program = 11,
        ProgramHole = 12,
    }

    export enum SaRangeColor {
        R1 = '#E11837',
        R2 = '#F3D43B',
        R3 = '#42CE11',
        R4 = '#3079F0'
    }

    export enum SaVarianceColor {
        R1 = '#FDB034',
        R2 = '#009EB2',
        R3 = '#D64E9A',
    }

    export enum SaVarianceRangeColor {
        R1 = '#E897E5',
        R2 = '#E28EE6',
        R3 = '#DA84E7',
        R4 = '#D27BE9',
        R5 = '#C870EA',
        R6 = '#BF65ED',
        R7 = '#B45BF0',
        R8 = '#A850F3',
        R9 = '#9B45F6',
        R10 = '#8432FC',
        R11 = '#E100FF'
    }

    export enum SaTableFilter {
        All,
        Filtered
    }

    export enum SaAlgorithm {
        Simple,                 // (Target VWC / Actual VWC)(Current % Adjust)
        DeltaPlusTodayEt
    }

    export enum StrikeGuardStatus {
        Alarm = 1,
        Warning = 2,
        Caution = 3,
        NoLightingDetected = 4,
        Error = 5,
        Offline = 6
    }

    export enum StrikeGuardStatusColor {
        Alarm = '#E11837',
        Warning = '#FA9A00',
        Caution = '#F3D43B',
        NoLightingDetected = '#42CE11',
        Error = 'white',
        Offline = '#D9DFE2'
    }

    export enum I3TableItemType {
        AssetDown,
        WorkOrder,
        MaintenanceDueAsset,
        OperatingStatus
    }

    export enum I3WorkOrderState {
        Unknown = 0,            // Support for legacy myTurf records (??)
        Unassigned = 1,         // WO is Created but Labors are not assigned
        InProgress = 2,         // WO is Created and Labors are Assigned
        WaitingForParts = 3,    // WO -Parts Are Needed
        MarkForReview = 4,      // WO is Marked for Review
        Closed = 5              // WO is Closed
    }

    export enum I3AssetType {
        Equipment = 1,
        Attachment = 2,
        Irrigation = 3,
        Other = 4
    }

    export enum I3UtilizationType {
        OperatingHours = 1,
        Odometer = 2
    }

    export enum I3IntervalType {
        ByUtilization = 1,
        ByDate = 2,
        ByUse = 3
    }

    export enum I3TaskStatus {
        NoMaintenanceDue = 0,
        MaintenanceComingDue = 1,
        MaintenanceDuePartsNeeded = 2,
        MaintenanceDuePartsOnHand = 3,
        WorkOrderCreatedTasksAssigned = 4,
        DownForRepairOrMaintenance = 5
    }

    export enum I3TaskType {
        Preventive = 1,
        Repair = 2,
        General = 3
    }

    export enum I3TaskSubType {
        Scheduled = 1,
        BreakIn = 2,
        AsNeeded = 3,
        DailyChecks = 4,
        Warranty = 5,
        Negligence = 6,
        WearAndTear = 7,
        General = 8,
        OneTime = 9
    }

    export enum TurfProStatus {
        // Off
        NoData,
        Off,
        OffAfterAlarm,

        // Waiting
        Alarm,
        Staying,
        WaitingAtStation,

        // Active
        WorkInProgress,
        Charging,
        Border,
        LeavingStation,
        HeadingChargingStation,
        HeadingForUnloadStation,
        Unloading
    }

    export enum TurfProStatusGroup {
        Unknown,
        Off,
        Waiting,
        Active
    }

    export enum TurfProAssetType {
        Unknown,
        Mower
    }

    export enum TurfProRobotType {
        Unknown,
        BallPicker,
        Mower
    }

    export enum TurfProRobotStatus {
        Unknown,
        Off,
        OffAfterAlarm,
        Idle,
        Alarm,
        Work,
        GoChargeStation,
        GoUnloadStation,
        LeaveStation,
        Charge,
        WaitStation,
        Border,
        Service,
        GoToPOI
    }

    export enum StationFilter {
        All,
        Enabled
    }

}
